import PatientList from './PatientList';
import PatientInfo from './PatientInfo';

export default {
  PatientList,
  PatientInfo,
};
